export class ProgressEvent {
  public name: string;
  public isResolved: boolean;

  constructor(name: string, isResolved: boolean = false) {
    this.name = name;
    this.isResolved = isResolved;
  }

  public static parse(name): ProgressEvent {
    return new ProgressEvent(name);
  }
}
